import { List, ListItem, ListItemIcon } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import { useContext, useEffect, useMemo, useState } from 'react';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';
import SaveIcon from '@mui/icons-material/Save';

const timeSince = (date: Date) => {
  const todaysDate = new Date();
  const dateDiff = todaysDate.valueOf() - date.valueOf();
  const seconds = Math.floor(dateDiff / 1000);

  let interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + ' years';
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + ' months';
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + ' days';
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + ' hours';
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + ' minutes';
  }
  return Math.floor(seconds) + ' seconds';
};

export default () => {
  const { state } = useContext(WorkflowEngineContext);

  const { lastUpdatedDate, lastUpdatedBy } = state;

  const getLastUpdatedDate = () => new Date(lastUpdatedDate || '');

  const [timeAgo, setTimeAgo] = useState<string>(
    timeSince(getLastUpdatedDate())
  );

  useEffect(() => {
    // update elapsed time every 30 seconds
    setTimeAgo(timeSince(getLastUpdatedDate()));
    const interval = setInterval(() => {
      setTimeAgo(timeSince(getLastUpdatedDate()));
    }, 30000);

    return () => clearInterval(interval);
  }, [lastUpdatedDate]);

  const renderView = () => (
    <List>
      <ListItem>
        <ListItemIcon>
          <SaveIcon
            sx={{
              paddingLeft: '30px',
              fontSize: '20px',
              paddingBottom: '0px'
            }}
          />
        </ListItemIcon>
        <ListItemText primary={`Updated ${timeAgo} ago by ${lastUpdatedBy}`} />
      </ListItem>
    </List>
  );

  return useMemo(
    () => (lastUpdatedDate && lastUpdatedBy ? renderView() : null),
    [timeAgo]
  );
};
